module.exports = __webpack_public_path__ + "assets/img/mainf.b6e7cf1d.png";